import { formatMillisecondsToDuration } from 'utils/formatting/dateTime';
import { formatAbbreviateNumber, formatLocalizedNumber, } from 'utils/formatting/number';
/**
 * Formats a `value` number according to `format`.
 *
 * @param value The number to format.
 * @param format The formatting method used to display the number.
 * @returns {string} The formatted number.
 */
export const formatInstrumentNumber = (value, format) => {
    switch (format) {
        case 'duration':
            return formatMillisecondsToDuration(value)
                .split(' ')
                .slice(0, 2)
                .join(' ');
        case 'count':
            return formatAbbreviateNumber(value);
        case 'number':
            return formatLocalizedNumber(value);
        case 'percentage':
            return `${formatLocalizedNumber(value)}%`;
        default:
            return '';
    }
};
